import { useSearchParams } from 'react-router-dom'
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs'
import { ServiceCatalogTab } from './ServiceCatalogTab'
import { PoliciesTab } from './PoliciesTab'
import { CategoriesTab } from './CategoriesTab'
import { GroupsTab } from './GroupsTab'

const VALID_TABS = ['catalog', 'policies', 'categories', 'groups'] as const
type PricingTab = (typeof VALID_TABS)[number]

export function PricingSettingsPage() {
  const [searchParams, setSearchParams] = useSearchParams()
  const tabParam = searchParams.get('tab') as PricingTab | null
  const activeTab = tabParam && VALID_TABS.includes(tabParam) ? tabParam : 'catalog'

  const handleTabChange = (tab: string) => {
    setSearchParams({ tab }, { replace: true })
  }

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold tracking-tight">Pricing Configuration</h1>
        <p className="text-muted-foreground mt-1">
          Manage your service catalog, pricing policies, and aircraft categories.
        </p>
      </div>

      <Tabs value={activeTab} onValueChange={handleTabChange}>
        <TabsList>
          <TabsTrigger value="catalog">Service Catalog</TabsTrigger>
          <TabsTrigger value="policies">Policies</TabsTrigger>
          <TabsTrigger value="categories">Aircraft Categories</TabsTrigger>
          <TabsTrigger value="groups">Service Groups</TabsTrigger>
        </TabsList>

        <TabsContent value="catalog" className="mt-6">
          <ServiceCatalogTab />
        </TabsContent>
        <TabsContent value="policies" className="mt-6">
          <PoliciesTab />
        </TabsContent>
        <TabsContent value="categories" className="mt-6">
          <CategoriesTab />
        </TabsContent>
        <TabsContent value="groups" className="mt-6">
          <GroupsTab />
        </TabsContent>
      </Tabs>
    </div>
  )
}
